<template>
    <v-dialog
        :model-value="modelValue"
        :max-width="maxWidth"
        :fullscreen-mobile="fullscreenMobile"
        :persistent="persistent"
        :aria-labelledby="titleId"
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <v-card :class="cardClass">
            <v-toolbar
                color="surface"
                tag="div"
            >
                <v-toolbar-title :id="titleId">{{ title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text
                v-if="$slots.default"
                class="pt-0 pb-2"
                :class="contentClass"
            >
                <slot />
            </v-card-text>
            <v-card-actions v-if="$slots.actions">
                <slot name="actions" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
import { useId } from 'vue';

interface Props {
    modelValue: boolean;
    title: string;
    maxWidth?: string;
    fullscreenMobile?: boolean;
    persistent?: boolean;
    cardClass?: string;
    contentClass?: string;
}

withDefaults(defineProps<Props>(), {
    maxWidth: '400px',
    fullscreenMobile: false,
    persistent: true,
    cardClass: '',
    contentClass: '',
});

defineEmits<{
    (event: 'update:modelValue', value: boolean): void;
}>();

const titleId = `BaseDialog-${useId()}-title`;
</script>
